import script from "./registered.vue?vue&type=script&setup=true&lang=js"
export * from "./registered.vue?vue&type=script&setup=true&lang=js"

import "./registered.vue?vue&type=style&index=0&id=0d3ff022&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\lunwenzhinengtougaopingtaitest2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d3ff022"]])

export default __exports__